import { call, put, takeEvery } from 'redux-saga/effects'

import { types } from '../../types'
import { loginUser, registerUser, getCareerField, checkExistEmail, captchaVerified, sendResetPasswordEmail } from '../apiRequests/authRequest'





function* handleLoginUser(action) {

    try {

        const response = yield call(loginUser, action.params)
        yield put({
            type: types.LOGIN_USER_SUCCESS,
            action: response,
        })
    } catch (error) {
        yield put({
            type: types.LOGIN_USER_ERROR,
            error: error.response.data.error,
        })
    }
}


function* handleSendResetPasswordEmail(action) {
    try {
        const response = yield call(sendResetPasswordEmail, action.params)
        yield put({
            type: types.SEND_RESET_PASSWORD_EMAIL_SUCCESS,
            action: response,
        })
    } catch (error) {
        yield put({
            type: types.SEND_RESET_PASSWORD_EMAIL_ERROR,
            error: error.response,
        })
    }
}


function* handleRegisterUser(action) {

    try {
        const response = yield call(registerUser, action.params)
        yield put({
            type: types.REGISTER_USER_SUCCESS,
            action: response,
        })
    } catch (error) {
        yield put({
            type: types.REGISTER_USER_ERROR,
            error: error.response,
        })
    }
}

function* handleGetCareerField(action) {
    try {
        const response = yield call(getCareerField, action.params)
        yield put({
            type: types.GET_CAREER_FIELD_SUCCESS,
            action: response,
        })
    } catch (error) {
        yield put({
            type: types.GET_CAREER_FIELD_ERROR,
            error: error.response,
        })
    }
}

function* handleGetCheckExistEmail(action) {

    try {
        const response = yield call(checkExistEmail, action.params)
        yield put({
            type: types.CHECK_EMAIL_EXIST_SUCCESS,
            action: response,
        })
    } catch (error) {
        yield put({
            type: types.CHECK_EMAIL_EXIST_ERROR,
            error: error.response,
        })
    }
}

function* handlerCaptchaVerified(action) {
    try {
        const response = yield call(captchaVerified, action.params)
        yield put({
            type: types.CAPTCHA_VERIFIED_SUCCESS,
            action: response,
        })
    } catch (error) {
        yield put({
            type: types.CAPTCHA_VERIFIED_ERROR,
            error: error.response,
        })
    }
}


function* watcherAuthSaga() {
    yield takeEvery(types.LOGIN_USER_REQUEST, handleLoginUser)
    yield takeEvery(types.REGISTER_USER_REQUEST, handleRegisterUser)
    yield takeEvery(types.GET_CAREER_FIELD_REQUEST, handleGetCareerField)
    yield takeEvery(types.CHECK_EMAIL_EXIST_REQUEST, handleGetCheckExistEmail)
    yield takeEvery(types.CAPTCHA_VERIFIED_REQUEST, handlerCaptchaVerified)
    yield takeEvery(types.SEND_RESET_PASSWORD_EMAIL_REQUEST, handleSendResetPasswordEmail)
}

export default watcherAuthSaga
